export const VoucherOrderStatuses = {
  Created: 'Created',
  Submitted: 'Submitted',
  InProgress: 'InProgress',
  Sent: 'Sent',
  Error: 'Error',
  Closed: 'Closed',
  Canceled: 'Canceled'
};
